// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1dDvG","buttons":"Footer_buttons__1sJAC"};